
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 51,
  height: 68,
  viewBox: "0 0 75 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M37.25 1c9.415 0 18.445 3.793 25.102 10.544C69.01 18.295 72.75 27.452 72.75 37c0 24.3-31.06 51.748-32.615 52.92A4.402 4.402 0 0 1 37.25 91a4.402 4.402 0 0 1-2.885-1.08l-.007-.007C32.924 88.653 1.75 61.257 1.75 37c0-9.548 3.74-18.705 10.398-25.456C18.805 4.793 27.834 1 37.25 1Zm-5.469 24.692a2.36 2.36 0 0 0-3.339 0 2.36 2.36 0 0 0 0 3.34L34.412 35l-5.97 5.969a2.36 2.36 0 0 0 0 3.339 2.36 2.36 0 0 0 3.34 0l5.968-5.97 5.969 5.97a2.36 2.36 0 0 0 3.339 0 2.36 2.36 0 0 0 0-3.34L41.088 35l5.97-5.969c.909-.909.909-2.416 0-3.325a2.36 2.36 0 0 0-3.338 0l-5.97 5.955-5.969-5.969Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.75 84c-4.326 1.484-7 3.532-7 5.793 0 4.533 10.745 8.207 24 8.207s24-3.674 24-8.207c0-2.261-2.674-4.309-7-5.793",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg width=\"51\" height=\"68\" viewBox=\"0 0 75 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M37.25 1C46.6652 1 55.695 4.79266 62.3525 11.5439C69.0101 18.2952 72.75 27.4523 72.75 37C72.7499 61.2991 41.6897 88.7483 40.1348 89.9199C39.331 90.6171 38.3077 91 37.25 91C36.1923 91 35.169 90.6171 34.3652 89.9199L34.3584 89.9131C32.9235 88.6521 1.7501 61.2567 1.75 37C1.75 27.4523 5.48994 18.2952 12.1475 11.5439C18.805 4.79266 27.8348 1 37.25 1ZM31.7812 25.6924C30.8583 24.7694 29.3653 24.7694 28.4424 25.6924C27.5194 26.6153 27.5194 28.1083 28.4424 29.0312L34.4111 35L28.4424 40.9688C27.5194 41.8917 27.5194 43.3847 28.4424 44.3076C29.3653 45.2306 30.8583 45.2306 31.7812 44.3076L37.75 38.3389L43.7188 44.3076C44.6417 45.2306 46.1347 45.2306 47.0576 44.3076C47.9806 43.3847 47.9806 41.8917 47.0576 40.9688L41.0889 35L47.0576 29.0312C47.9669 28.122 47.9669 26.6154 47.0576 25.7061C46.135 24.7834 44.6427 24.7831 43.7197 25.7051L37.75 31.6611L31.7812 25.6924Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M20.75 84C16.4242 85.4844 13.75 87.532 13.75 89.7931C13.75 94.3256 24.4952 98 37.75 98C51.0048 98 61.75 94.3256 61.75 89.7931C61.75 87.5319 59.0758 85.4844 54.7499 84\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3\" stroke-linecap=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/point.ee64106579feab685166fe0734b176f3.svg"),
        {
          React: SvgPoint,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      